<template>
  <div class="conditional-media">
    <div
      class="media-container"
      v-if="files.length > 0 && selectedFile && showPreview"
    >
      <video ref="conditional-media-video" :key="videoKey" v-if="selectedFile.type === 'VIDEO'" controls>
        <source :src="prefix + selectedFile.path" />
      </video>

      <audio v-if="selectedFile.type === 'AUDIO'" controls>
        <source :src="prefix + selectedFile.path" type="audio/mp3" />
      </audio>

      <img
        v-if="selectedFile.type === 'IMAGE'"
        :src="prefix + selectedFile.path"
        style="width:100%; height:100%; object-fit:fill"
      />

      <a
        v-if="selectedFile.type === 'DOCUMENT' || selectedFile.type === 'EXCEL'"
        :style="{
          backgroundColor: `#fff`,
          borderRadius: '10px',
          padding: '15px 25px',
          fontSize: '20px',
        }"
        :href="`${prefix}${selectedFile.path}`"
        download
      >
        Yüklə
      </a>

      <iframe
        v-if="selectedFile.type === 'PDF'"
        style="width: 100%; height: 100%"
        :src="prefix + selectedFile.path"
      />

      <a-tooltip
        title="Örtük mediası et"
        v-if="
          (selectedFile.type === 'IMAGE' || selectedFile.type === 'VIDEO') &&
          currentStep.canUpdateProblemInfo
        "
      >
        <a-button
          shape="circle"
          class="cover-btn"
          :class="{ selected: selectedFile.isMain }"
          icon="check"
          @click="makeCover(selectedFile)"
        ></a-button>
      </a-tooltip>
      <div v-if="selectedFile.uploadDateStr" class="gradient-layer">
        <div class="date">{{ selectedFile.uploadDateStr }}</div>
      </div>
    </div>

    <div v-if="files.length == 0" class="no-file">
      <img
        src="../../../assets/imgs/no-file.png"
        style="width: 300px; height: auto"
      />
    </div>

    <div
      class="file-list-container"
      v-if="!showPreview || files.length > 1 || multipleSelection"
    >
      <ul class="file-list">
        <li v-for="(file, index) in files" :key="index" class="file-list-item">
          <button
            @click="changeMedia(file)"
            :class="{
              selected: showPreview && file.selected,
              'selected-icon': (showPreview && file.selected && differentSelectedType && multipleSelection)
            }"
            style="position: relative;"
          >
            <div v-if="showPreview && file.selected && differentSelectedType && multipleSelection" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); height: 30px; width: 30px; border-radius: 50%; display: flex; align-items: center; justify-content: center; background-color: #26C08A;">
              <a-icon  type="check" style="color: #fff;" />
            </div>

            <img
              v-if="file.type === 'IMAGE'"
              class="fimage"
              :src="prefix + file.thumbNailPath"
            />
            <img
              v-if="file.type === 'VIDEO'"
              class="fimage"
              :src="prefix + file.thumbNailPath"
            />
            <div
              v-if="file.type === 'AUDIO'"
              class="fother"
              style="
                background-color: rgb(38, 192, 138);
                width: 100%;
                height: 100%;
              "
            >
              <a-icon
                type="audio"
                style="
                  color: white;
                  font-size: 62px;
                  position: absolute;
                  top: 27px;
                  left: 29px;
                "
              />
            </div>
            <img
              v-if="file.type === 'DOCUMENT'"
              style="background: white; float: left"
              src="../../../assets/imgs/file_formats3_docx-512.png"
            />
            <img
              v-if="file.type === 'PDF'"
              style="background: white"
              src="../../../assets/imgs/adobe-acrobat-pdf-file-512.png"
            />
            <a-icon class="main-icon" v-if="file.isMain" type="check-circle" />
            <div v-if="!showPreview && file.selected" class="checked-layer">
              <a-icon type="check" />
            </div>
            <div v-if="file.uploadDateStr" class="gradient-layer">
              {{ file.uploadDateStr }}
            </div>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { URL } from "@/utils/api";
import mixin from "@/mixins/index";
import { v4 as uuid } from 'uuid'

export default {
  name: "ConditionalMedia",
  mixins: [mixin],
  props: {
    filesList: Array,
    cover: String,
    showPreview: {
      type: Boolean,
      default: true,
    },
    multipleSelection: {
      type: Boolean,
      default: false,
    },
    selectedIndex: Number,
    differentSelectedType: {
      type: Boolean,
      default: false,
    },
    isVisible: { type: Boolean, default: true },
  },
  data() {
    return {
      files: [],
      selectedFile: {},
      prefix: URL[process.env.NODE_ENV].file_url,
      videoKey: uuid(),
    };
  },
  methods: {
    changeMedia(file) {
      if (!this.multipleSelection) {
        this.selectedFile.selected = false;
      }
      if (this.showPreview) this.$set(this, "selectedFile", file);
      if (this.multipleSelection) {
        file.selected = !file.selected;
      } else {
        file.selected = true;
      }
      if (
        this.selectedFile.type === "VIDEO" ||
        this.selectedFile.type === "AUDIO"
      ) {
        let medias = document.getElementsByTagName(
          this.selectedFile.type.toLowerCase()
        );
        if (medias.length > 0) medias[0].load();
      }

      if (!this.multipleSelection) {
        this.$emit("change", this.selectedFile);
        return;
      }
      this.$emit(
        "change",
        this.files.filter((item) => {
          return item.selected;
        })
      );
    },
    makeCover(file) {
      this.$emit("coverChanged", file);
    },
    newFileOb({ element, type }) {
      return {
        path: element.path,
        type: type,
        latitude: element.latitude,
        longitude: element.longitude,
        executive: element.executive,
        addresses: element.addresses,
        distance: element.distance,
        address: element.address,
        sameAddress: element.sameAddress,
      };
    },
    copy() {
      if (this.filesList.length === 0) {
        this.selectedFile = null;
        this.files = [];
        return;
      }
      this.files = this.filesList.map((f, i) => {
        if (f.type === "VIDEO")
          return {
            ...f,
            index: i,
            selected: false,
            thumbNailPath:
              "thumbnail_" + f.path.slice(0, f.path.indexOf(".")) + ".png",
          };
        else
          return {
            ...f,
            index: i,
            selected: false,
            thumbNailPath: "thumbnail_" + f.path,
          };
      });
     
      const firstImageFile = this.files.findIndex(f => f.type === "IMAGE")
      
      if(firstImageFile>-1){
          this.files = [
            this.files[firstImageFile],
            ...this.files.filter((_, i) => i !== firstImageFile)
          ];

          this.makeCover(this.files[0])
      }
      
      if (this.cover) {
        this.files = this.files.map((item) => {
          item.isMain = this.cover === item.path;
          return item;
        });
      }
      
      this.selectedFile = this.selectedIndex
        ? this.files[this.selectedIndex]
        : this.files[0];
      this.selectedFile.selected = false;
      if (!this.multipleSelection) this.$emit("change", this.selectedFile);
      else this.$emit("change", [this.selectedFile]);
    },
  },
  watch: {
    isVisible: {
      immediate: true,
      handler: function(val) {
        if (!val && this.$refs['conditional-media-video']) {
          this.$refs['conditional-media-video'].pause();
        }
      }
    },
    cover: function (newVal) {
      if (newVal)
        this.files = this.files.map((item) => {
          item.isMain = this.cover === item.path;
          return item;
        });
    },
    selectedIndex: function (newVal) {
      for (let i = 0; i < this.files.length; i++) {
        this.files[i].selected = i === newVal;
      }
    },
    filesList: {
      immediate: true,
      handler: function (val) {
        this.videoKey = uuid();
        this.copy();
      }
    },
  },
  created() {
    this.copy();
  },
};
</script>

<style lang="scss" src="./index.scss"></style>

<style>
.mapouter {
  position: relative;
  text-align: right;
}
.gmap_canvas {
  overflow: hidden;
  background: none !important;
}
#gmap_canvas {
  width: 100%;
  height: 280px;
}
</style>
